var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-scroll h-100" }, [
    _vm._m(0),
    _vm._v(" "),
    !_vm.is_load
      ? _c(
          "div",
          { staticClass: "loader_calendar w-100 text-center pt-5 mt-5" },
          [
            _c("sync-loader", {
              attrs: { loading: true, color: "#7a59ad", size: "10px" },
            }),
          ],
          1
        )
      : _c(
          "ul",
          { staticClass: "notification" },
          _vm._l(this.feed_data, function (feed) {
            return _c("li", { staticClass: "unread" }, [
              _c(
                "div",
                {
                  staticClass: "d-flex align-items-center show-child-on-hover",
                },
                [
                  _c("span", { staticClass: "d-flex flex-column flex-1" }, [
                    _c(
                      "span",
                      { staticClass: "name d-flex align-items-center" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(feed.committer_name) +
                            "\n                        "
                        ),
                        _c(
                          "span",
                          { staticClass: "badge badge-warning fw-n ml-1" },
                          [_vm._v(_vm._s(feed.short_id))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "msg-a fs-sm" }, [
                      _vm._v(
                        "\n                          " +
                          _vm._s(feed.title) +
                          "\n                      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-nano text-muted mt-1" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(feed.created_at) +
                          "\n                      "
                      ),
                    ]),
                  ]),
                ]
              ),
            ])
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "notification" }, [
      _c("li", { staticClass: "unread" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center show-child-on-hover" },
          [
            _c("span", { staticClass: "d-flex flex-column flex-1" }, [
              _c("span", { staticClass: "name d-flex align-items-center" }, [
                _vm._v("Administrator "),
                _c("span", { staticClass: "badge badge-success fw-n ml-1" }, [
                  _vm._v("UPDATE"),
                ]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "msg-a fs-sm" }, [
                _vm._v("\n                        System updated to version "),
                _c("strong", [_vm._v("3.00")]),
                _vm._v(" "),
                _c("i", { staticClass: "fal fa-deer" }),
                _vm._v(" "),
                _c("i", { staticClass: "fal fa-deer" }),
                _vm._v(" "),
                _c("i", { staticClass: "fal fa-deer" }),
                _vm._v(" "),
                _c("i", { staticClass: "fal fa-deer" }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "fs-nano text-muted mt-1" }, [
                _vm._v("01.09.2020"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "show-on-hover-parent position-absolute pos-right pos-bottom p-3",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "text-muted",
                    attrs: { href: "#", title: "delete" },
                  },
                  [_c("i", { staticClass: "fal fa-deer" })]
                ),
              ]
            ),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }